// extracted by mini-css-extract-plugin
export default {"content":"X7M6vMRd","subtitle":"PZKevlu2","editorial":"xDg3vZFz"};